import React from "react";

const About = () => {
  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold">Welcome to About Page</h1>
      <p className="text-gray-600 mt-4">
        Discover amazing destinations for your next adventure.
      </p>
    </div>
  );
};

export default About;
